import { Component, Input } from "@angular/core";

@Component({
  selector: "app-fax-filter-list-wrapper",
  templateUrl: "./fax-filter-list-wrapper.component.html",
  styleUrls: ["./fax-filter-list-wrapper.component.scss"],
})
export class FaxFilterListWrapperComponent {
  @Input() title = "";

  isExpanded = true;

  toggleExpansion() {
    this.isExpanded = !this.isExpanded;
  }
}
